// extracted by mini-css-extract-plugin
module.exports = {"events":"styles_events__GC1Bt","paginations":"styles_paginations__DHVHD","filter":"styles_filter__dX5_L","datePicker":"styles_datePicker__AyPj6"};